import { render, staticRenderFns } from "./cabinet-fl44-proposal-card.vue?vue&type=template&id=70f8e257&scoped=true&"
import script from "./cabinet-fl44-proposal-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-proposal-card.vue?vue&type=style&index=0&id=70f8e257&scoped=true&lang=css&"
import style1 from "./cabinet-fl44-proposal-card.vue?vue&type=style&index=1&id=70f8e257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8e257",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f8e257')) {
      api.createRecord('70f8e257', component.options)
    } else {
      api.reload('70f8e257', component.options)
    }
    module.hot.accept("./cabinet-fl44-proposal-card.vue?vue&type=template&id=70f8e257&scoped=true&", function () {
      api.rerender('70f8e257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/cabinet-fl44-proposal-card.vue"
export default component.exports